<template>
  <el-form
    ref="importForm"
    :model="model"
    label-width="15em"
    label-position="left"
  >
    <slot></slot>
    <template v-if='formMode !== "master"'>
      <BillingYm v-model="billingYm" :required="true" mode="edit" :actualprop=true :actualmode=actualmode />
    </template>
    <el-form-item label="データ取込" class="import-mode" prop="data_capture" :required="true" >

      <el-radio-group>
      <el-radio-group v-model="dataCapture">
            <el-radio v-if = 'dispAllCases()' label="1">全データ入替</el-radio>
            <el-radio label="2">データ追加</el-radio>
          </el-radio-group>
      </el-radio-group>
    </el-form-item>
    <ImportFile
      ref="importFile"
      :label="label"
      :action="action"
      :extension="extension"
      :params="model"
      @import-success="importSuccess"
      @import-error="importError"
    />
  </el-form>
</template>

<script>
import BillingYm from '@/components/molecules/form/select/BillingYm.vue'
import ImportFile from '@/components/molecules/form/upload/ImportFile.vue'
import Encoding from 'encoding-japanese'

export default {
  components: {
    BillingYm,
    ImportFile
  },
  model: {
    prop: 'model'
  },
  props: {
    model: Object,
    label: String,
    action: String,
    extension: String,
    params: Object,
    formMode: {
      type: String,
      default: 'master'
    },
    actualmode: {
      type: Number,
      default: 1
    },
    dispAllCases: {
      type: Function,
      default: () => true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    billingYm: {
      get () {
        return this.model.billing_ym
      },
      set (billingYm) {
        const form = { ...this.model }
        form.billing_ym = billingYm
        this.$emit('input', form)
      }
    },
    dataCapture: {
      get () {
        return this.model.data_capture
      },
      set (dataCapture) {
        const form = { ...this.model }
        form.data_capture = dataCapture
        this.$emit('input', form)
      }
    }
  },
  methods: {
    import () {
      this.$refs.importFile.import()
    },
    importSuccess (res) {
      this.$emit('import-success', res)
    },
    importError (res) {
      this.$emit('import-error', res)
    },
    httpRequest (request) {
      const reader = new FileReader()
      reader.onload = (e) => {
        const array = new Uint8Array(e.target.result)
        const detected = Encoding.detect(array)
        const utf8Array = Encoding.convert(array, {
          to: 'UNICODE',
          from: detected
        })
        const params = { ...request.data }
        params.import_data = Encoding.codeToString(utf8Array)
        this.$axios
          .post(request.action, params)
          .then(res => {
            request.onSuccess(res)
          })
          .catch(e => {
            request.onError(e)
          })
      }
      reader.readAsArrayBuffer(request.file)
    },
    clear () {
      this.$refs.importForm.resetFields()
      this.$refs.importFile.clear()
      this.billingYm = this.getDefaultBillingYm()
    },
    validate () {
      return new Promise((resolve, reject) => {
        this.$refs.importForm.validate((valid) => {
          if (valid) {
            resolve(valid)
          } else {
            reject(new Error('validate error'))
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.upload {
  display: flex;
  ::v-deep .el-upload {
    order: 2;
  }
  ::v-deep .el-upload-list {
    order: 1;
    width: 100%;
    margin-right: 1em;
    .el-upload-list__item {
      margin-top: 0;
    }
  }
}
</style>
